// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","637":"order","976":"tool"}[chunkId] + "." + {"177":"bb2e7472","637":"827be37b","976":"32c4c9ae"}[chunkId] + ".js";
};